import React, { useState } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { addUserSlice, addUserState } from './AddModalSlice'
import { usersSlice } from '../UsersSlice'

// API
import API from '../../../services/api/api'

// Components
import Modal from '../../../components/Modal/Modal'
import { InputField } from '../../../components/FormElements/FormElements'
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'
import { EmployeesMenu, RolesMenu } from '../../../components/PredefinedMenus/PredefinedMenus'
import { useNotification } from '../../../services/usenotification'
import { useAPI } from '../../../services/hoc/useAPI'


export default () => {
    
    // Translation
    const t = useTranslation()
    const {alertError500}=useNotification()

    // Redux
    const dispatch = useDispatch()
    const state = useSelector( ( state: { add_user: addUserState } ) => state.add_user )

 const ENDPOINTS = useAPI()
    // Hooks
    const [ showErrors, setShowErrors ] = useState<boolean>(false)

    // Add user
    const add = ( e: React.FormEvent<HTMLFormElement> ) => {
        
        e.preventDefault()

        if( state.fields.email === "" || ( state.fields.password === "" && state.editId === 0 ) || state.fields.role?.id === 0 ) {
            setShowErrors(true)
            return
        }

        dispatch( addUserSlice.actions.setIsLoading(true) )
        const endpoint = state.editId ? ENDPOINTS.users().update : ENDPOINTS.users().store
        endpoint({ id: state.editId, password: state.fields.password || "", email: state.fields.email || "", role_id: state.fields.role?.id || 0, employee_id: state.fields.employee?.id || 0 })
        .then((response: any) => {
            dispatch( addUserSlice.actions.setIsSuccess(true) )
            dispatch( addUserSlice.actions.setIsLoading(false) )
            setTimeout(() => {
                toggle()
                dispatch( usersSlice.actions.addUsers([{
                    id: response.data.data.id,
                    employee: response.data.data.employee,
                    name: response.data.data.employee.name,
                    email: response.data.data.email,
                    role: response.data.data.role
                }]) )
            }, 1000);
        }).
        catch((err:any)=>{
            dispatch( addUserSlice.actions.setIsLoading(false) )
            alertError500(err)
        })

    }

    const toggle = () => {
        dispatch( addUserSlice.actions.setIsOpen(!state.isOpen) )
        dispatch( addUserSlice.actions.init() )
    }

    return(
        <Modal open={state.isOpen} toggle={toggle}>

            { state.isLoading ? <WhiteboxLoader /> : ""}

            { state.isSuccess ? <SuccessMark /> : ""}
            
            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{ state.editId ? t("edit_user") : t("add_to_users")}</h2>

            <form onSubmit={add} style={{ width: 400, maxWidth: "100%" }}>

                <EmployeesMenu
                    placeholder={t("select_employee")}
                    has_user={"No"}
                    onChange={(selected: { value: number, label: string }) => dispatch(addUserSlice.actions.set({ employee: { id: selected.value, name: selected.label } }))}
                    value={state.fields.employee?.id ? { value: state.fields.employee?.id, label: state.fields.employee?.name } : null}
                    error={(showErrors && state.fields.employee?.id === 0) ? t("required_error") : ""}
                />

                <RolesMenu
                    placeholder={t("select_role")}
                    onChange={(selected: { value: number, label: string }) => dispatch(addUserSlice.actions.set({ role: { id: selected.value, name: selected.label } }))}
                    value={state.fields.role?.id ? { value: state.fields.role?.id, label: state.fields.role?.name } : null}
                    error={(showErrors && state.fields.role?.id === 0) ? t("required_error") : ""}
                />

                <InputField
                    type="email"
                    label={t("email") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addUserSlice.actions.set({ email: e.target.value }))}
                    value={state.fields.email}
                    error={(showErrors && state.fields.email === "") ? t("required_error") : ""}
                />

                <InputField
                    type="password"
                    label={t("password") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addUserSlice.actions.set({ password: e.target.value }))}
                    value={state.fields.password}
                    error={(showErrors && state.fields.password === "" && state.editId === 0) ? t("required_error") : ""}
                />

                <button className="button round bg-gold color-white margin-top-30" style={{ padding: "0 80px", marginBottom: 5 }}>{t("submit")}</button>

            </form>

        </Modal>
    )

}